import React from 'react';
import './anchor-styles.css';

/**
 * Invoice List/Table Component
 */
const InvoiceList = ({ 
  invoices = [], 
  loading, 
  onViewDetails, 
  onViewNotes = () => {},
  onAccept = () => {},
  onReject = () => {},
  pagination,
  onPageChange,
  onLimitChange 
}) => {

  if (loading) {
    return (
      <div className="invoice-list-loading">
        <div className="text-center" style={{ padding: '50px' }}>
          <i className="fa fa-spinner fa-spin fa-3x"></i>
          <p style={{ marginTop: '15px' }}>Loading invoices...</p>
        </div>
      </div>
    );
  }

  if (!invoices || invoices.length === 0) {
    return (
      <div className="invoice-list-empty">
        <div className="text-center" style={{ padding: '50px' }}>
          <i className="fa fa-inbox fa-3x" style={{ color: '#ccc' }}></i>
          <h3 style={{ marginTop: '15px', color: '#999' }}>No Invoices Found</h3>
          <p style={{ color: '#999' }}>Try adjusting your filters</p>
        </div>
      </div>
    );
  }

  return (
    <div className="invoice-list">
      {/* Invoice Table */}
      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover anchor-invoice-table">
          <thead>
            <tr>
              <th style={{ minWidth: '160px', textAlign: 'center' }}>Created At</th>
              <th style={{ minWidth: '160px', textAlign: 'center' }}>Invoice No.</th>
              <th style={{ minWidth: '150px', textAlign: 'center' }}>Product Type</th>
              <th style={{ minWidth: '140px', textAlign: 'center' }}>Mobile</th>
              <th style={{ minWidth: '150px', textAlign: 'right' }}>Requested Loan Amt</th>
              <th style={{ minWidth: '130px', textAlign: 'right' }}>Amount</th>
              <th style={{ minWidth: '130px', textAlign: 'center' }}>Invoice Date</th>
              <th style={{ minWidth: '130px', textAlign: 'center' }}>Due Date</th>
              <th style={{ minWidth: '150px', textAlign: 'center' }}>Status</th>
              <th style={{ minWidth: '160px', textAlign: 'center' }}>Action</th>
              <th style={{ minWidth: '130px', textAlign: 'center' }}>Remarks</th>
              <th style={{ minWidth: '140px', textAlign: 'center' }}>Invoice ID</th>
              <th style={{ minWidth: '170px', textAlign: 'center' }}>Supplier Name</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map((invoice) => (
              <tr key={invoice.id}>
                <td style={{ textAlign: 'center' }}>{formatDateTime(invoice.createdAt)}</td>
                <td style={{ textAlign: 'center' }}>
                  <span
                    className="text-primary"
                    style={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: 500 }}
                    onClick={() => onViewDetails(invoice.invoiceId || invoice.id)}
                  >
                    {invoice.invoiceNumber || 'N/A'}
                  </span>
                </td>
                <td style={{ textAlign: 'center' }}>{invoice.productType === 'SCF ANCHOR' ? 'REVERSE FACTORING' : (invoice.productType || 'N/A')}</td>
                <td style={{ textAlign: 'center' }}>{invoice.mobile || 'N/A'}</td>
                <td style={{ textAlign: 'right' }}>₹{formatAmount(invoice.requestedAmount || 0)}</td>
                <td style={{ textAlign: 'right' }}>₹{formatAmount(invoice.amount)}</td>
                <td style={{ textAlign: 'center' }}>{formatDate(invoice.invoiceDate)}</td>
                <td style={{ textAlign: 'center', color: '#555' }}>{formatDate(invoice.dueDate)}</td>
                <td style={{ textAlign: 'center' }}>
                  {renderStatusBadge(invoice)}
                </td>
                <td style={{ textAlign: 'center' }}>
                  {renderAction(invoice, onAccept, onReject)}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <span 
                    className="text-primary" 
                    style={{ 
                      cursor: 'pointer',
                      textDecoration: 'underline',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '5px'
                    }}
                    onClick={() => onViewNotes(invoice)}
                  >
                    <i className={invoice.remarks || invoice.approvalRemarks || invoice.rejectionReason ? "fa fa-eye" : "fa fa-plus"}></i>
                    {invoice.remarks || invoice.approvalRemarks || invoice.rejectionReason ? 'View Notes' : 'Add Note'}
                  </span>
                </td>
                <td style={{ textAlign: 'center' }}>
                  <span
                    className="text-primary"
                    style={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: 500 }}
                    onClick={() => onViewDetails(invoice.invoiceId || invoice.id)}
                  >
                    {invoice.invoiceId || 'N/A'}
                  </span>
                </td>
                <td style={{ textAlign: 'center' }}>{invoice.supplierName || 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {pagination && (
        <div className="invoice-pagination">
          <div className="pagination-info">
            Showing {pagination.from || 1} - {pagination.to || invoices.length} of {pagination.total || 0} invoices
          </div>
          <div className="pagination-controls">
            <div className="items-per-page" style={{ marginRight: '20px' }}>
              <label>Items per page: </label>
              <select 
                value={pagination.limit || 20}
                onChange={(e) => onLimitChange(parseInt(e.target.value))}
                className="form-control"
                style={{ width: 'auto', display: 'inline-block', marginLeft: '5px' }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <div className="pagination-buttons">
              <button
                className="btn btn-default btn-sm"
                onClick={() => onPageChange(pagination.currentPage - 1)}
                disabled={pagination.currentPage === 1}
              >
                <i className="fa fa-chevron-left"></i> Prev
              </button>
              <span style={{ margin: '0 15px' }}>
                Page {pagination.currentPage} of {pagination.totalPages}
              </span>
              <button
                className="btn btn-default btn-sm"
                onClick={() => onPageChange(pagination.currentPage + 1)}
                disabled={pagination.currentPage === pagination.totalPages}
              >
                Next <i className="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Helper Functions
const formatAmount = (amount) => {
  return amount?.toLocaleString('en-IN') || '0';
};

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', { 
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric' 
  });
};

const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleString('en-IN', { 
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

const getDisplayStatus = (invoice) => {
  if (invoice.buyerDecision === 'Accepted') return 'In Progress';
  return invoice.status || 'New';
};

const renderStatusBadge = (invoice) => {
  const displayStatus = getDisplayStatus(invoice);
  return (
    <span style={{
      color: '#333',
      fontWeight: 400,
      fontSize: '14px'
    }}>
      {displayStatus}
    </span>
  );
};

const renderAction = (invoice, onAccept, onReject) => {
  if (!invoice.buyerDecision) {
    return (
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
        <button className="btn btn-success btn-sm" onClick={() => onAccept(invoice)}>
          Accept
        </button>
        <button className="btn btn-danger btn-sm" onClick={() => onReject(invoice)}>
          Reject
        </button>
      </div>
    );
  }
  if (invoice.buyerDecision === 'Accepted') {
    return (
      <span style={{
        color: '#4CAF50',
        fontWeight: 600
      }}>
        ✅ Accepted
      </span>
    );
  }
  return (
    <span style={{
      color: '#F44336',
      fontWeight: 600
    }}>
      ❌ Rejected
    </span>
  );
};

export default InvoiceList;

